<template>
  <div class="text-center pointer toolbar">
    <ul class="ul-cls">
      <li class="zhiCustomBtn">
        <a href="https://work.weixin.qq.com/kfid/kfcd664a576a4abadcc" target="_blank">
          <svg-icon icon-name="service" />
          <div class="text">在线客服</div>
        </a>
      </li>
      <li v-if="!isZnt" @click="$parent.advice">
        <svg-icon icon-name="advice" />
        <div class="text">意见反馈</div>
      </li>
      <li>
        <svg-icon icon-name="tel" />
        <div class="text">400-810-5353</div>
      </li>
    </ul>
    <img @click="scrollTo" :style="{ opacity: opacity }" class="top" src="./images/top.png" />
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import isInZnt from '@/utils/znt.js';

export default {
  data() {
    return {
      opacity: 0,
      isZnt: isInZnt(),
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, true);
  },
  methods: {
    scroll() {
      if (document.documentElement.scrollTop > 110) {
        this.opacity = 1;
      } else {
        this.opacity = 0;
      }
    },
    scrollTo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
};
</script>
